import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import type {
  GetNeedsApprovalStatsResponse,
  GetTaskStatsResponse,
} from 'src/queries/organizations/activity.queries'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getUserTaskStats = async (): Promise<GetTaskStatsResponse> =>
  getResponseData(
    axios.get<GetTaskStatsResponse>(
      `/activities/statistics/missing`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getUserNeedsApprovalStats =
  async (): Promise<GetNeedsApprovalStatsResponse> =>
    getResponseData(
      axios.get<GetNeedsApprovalStatsResponse>(
        `/activities/statistics/approvals`,
        getRequestConfig(RequestConfig.Default),
      ),
    )
